import {
  CHANGE_TUTORIAL_INDEX,
  TOGGLE_COMPANY_LIST,
  TOGGLE_RESET_PASSWORD_VIEW,
  TOGGLE_SIGN_OUT_MODAL,
  TOGGLE_TUTORIAL_MODAL,
} from 'actions/actionTypes';

export const toggleSignOutModal = (flag: boolean) => ({
  type: TOGGLE_SIGN_OUT_MODAL,
  flag,
});

export const toggleResetPasswordView = (flag: boolean) => ({
  type: TOGGLE_RESET_PASSWORD_VIEW,
  flag,
});

export const toggleTutorialModal = (flag: boolean) => ({
  type: TOGGLE_TUTORIAL_MODAL,
  flag,
});

export const changeTutorialIndex = (index: number) => ({
  type: CHANGE_TUTORIAL_INDEX,
  index,
});

export const toggleCompanyList = (flag: boolean) => ({
  type: TOGGLE_COMPANY_LIST,
  flag,
});
